import { usePreEligibilityDataSnapshot } from "../../../funnels/pre-eligibility/state/preEligibilityState";
import { format } from "date-fns";
import { useBrandSnapshot } from "../../branding";
import { getDisruptionTypeDetails } from "../track/utils";
import analytics from "../../../../tracking/analytics";

export function useTrackEnquiryStepComplete({ currentStep }: { currentStep?: string }) {
  const { claimDetails, itineraryFlights, flightDetails } = usePreEligibilityDataSnapshot();
  const disruptedFlight =
    itineraryFlights?.find((flight) => flight.disrupted) || itineraryFlights[0];

  const brand = useBrandSnapshot();

  return () =>
    analytics.track("enquiryStepComplete", {
      brand: brand?.name || "",
      user_city: "",
      user_country: "",
      trip_departure: disruptedFlight?.departureAirport?.iata || "",
      trip_destination: disruptedFlight?.arrivalAirport?.iata || "",
      trip_date: disruptedFlight?.flightDate
        ? format(disruptedFlight.flightDate, "dd-MM-yyyy")
        : "",
      connecting_flights: flightDetails.connections.length > 1 ? "Y" : "N",
      connections: flightDetails.connections.map((c) => c.airport?.iata || ""),
      disruption_segment: {
        source: disruptedFlight?.departureAirport?.iata || "",
        destination: disruptedFlight?.arrivalAirport?.iata || "",
      },
      disruption_type: claimDetails.claimType || "",
      ...getDisruptionTypeDetails({
        delay: claimDetails.totalDelay || "",
        claimType: claimDetails.claimType || "",
        airlineReason: claimDetails.airlineReason,
        informedBeforehand: claimDetails.informedBeforehand || "",
        voluntarilySurrendered: claimDetails.voluntarilySurrendered || false,
      }),
      total_compensation: 0,
      user_compensation: 0,
      fellow_passengers: 0,
      step_name: currentStep || "",
      funnel_name: "preEligibility",
    });
}
